
import { computed, reactive, ref } from "vue";
import { useStore } from 'vuex' // useStore ===vue2.0中的this.$store
import logo_b from '@/assets/image/sidebar/logo_b.png'
import logo from '@/assets/image/sidebar/logo.png'
export default {
  setup() {
    const store = useStore()
    const title = ref<string>('客户管理平台')

    const isCollapse = computed(() => {
      return !store.state.app.isCollapse
    })
    return {
      store,
      title,
      isCollapse,
      logo_b,
      logo
    }
  }
}


